import { APP_PERMISSIONS } from '@/services/roleService';

import { BaseCompanySellingUrl, BaseCompanyGrowingUrl, BaseCompanyManagementUrl } from './../menus/__base';

import StationsPage from '@/pages/CompanyPages/Management/Stations';
import NotificationsPage from '@/pages/CompanyPages/Management/Notifications';
import CompanySettingsPage from '@/pages/CompanyPages/Growing/CompanySettings';
import SubscriptionsPage from '@/pages/CompanyPages/Growing/Subscriptions';
import StaffsPage from '@/pages/CompanyPages/Growing/Staffs';
import SeatModelsPage from '@/pages/CompanyPages/Management/SeatModels';
import TicketsClassPage from '@/pages/CompanyPages/Management/TicketClasses';
import BusesPage from '@/pages/CompanyPages/Management/Buses';
import BusModelsPage from '@/pages/CompanyPages/Management/BusModels';
import PassengersPage from '@/pages/CompanyPages/Management/Passengers';
import RoutesPage from '@/pages/CompanyPages/Management/Routes';
import BaggageTariffsPage from '@/pages/CompanyPages/Management/BaggageTariffs';
import TicketTariffsPage from '@/pages/CompanyPages/Management/TicketTariffs';
import TripsPage from '@/pages/CompanyPages/Management/Trips';
import DiscountsPage from '@/pages/CompanyPages/Growing/Discounts';
import TripsCalendarPage from '@/pages/CompanyPages/Management/TripsCalendar';
import TripDetailsPage from '@/pages/CompanyPages/Management/TripDetails';
import RegistersPage from '@/pages/CompanyPages/Management/Registers';
import TerminalsPage from '@/pages/CompanyPages/Management/Terminals';
import ManageTicketsPage from '@/pages/CompanyPages/Management/Tickets';
import BookingPage from '@/pages/CompanyPages/Management/Bookings/BookingPage';
import TicketConflictPage from '@/pages/CompanyPages/Management/TicketConflict';
import TariffAgeIssuesPage from '@/pages/CompanyPages/Management/TariffAgeIssues';
import ControlReviewsPage from '@/pages/CompanyPages/Management/ControlReviews';
import CreditNotesPage from '@/pages/CompanyPages/Management/CreditNotes';
import RolesPage from '@/pages/CompanyPages/Growing/Roles';
import SellOnTheGoBookingPage from '@/pages/CompanyPages/Management/SellOnTheGoBookings/BookingPage';
import TripStatusReportPage from '@/pages/CompanyPages/Selling/TripStatusReport';
import CompanyDashboard from '@/pages/CompanyPages/Dashboard';
import SalesReportPage from '@/pages/CompanyPages/Selling/SalesReport';
import TripsReportPage from '@/pages/CompanyPages/Selling/TripsReport';
import TripDetailsReport from '@/pages/CompanyPages/Selling/TripDetailsReport';
import TripIncomeReport from '@/pages/CompanyPages/Selling/TripIncomeReport';
import UnEarnedRevenueReport from '@/pages/CompanyPages/Selling/UnEarnedRevenueReport';
import SaleWithGroupReportPage from '@/pages/CompanyPages/Selling/SaleWithGroupReport';
import SellOnTheGoReconciliationPage from '@/pages/CompanyPages/Management/SellOnTheGoReconciliation';
import BaggageReconciliationPage from '@/pages/CompanyPages/Management/BaggageReconciliation';
import ShipmentManagementPage from '@/pages/CompanyPages/Management/ShipmentManagement';

type RouteType = {
  path: string;
  component: any;
  exact: boolean;
  permissions?: string[] | '*';
};

// ------------------------------------------------------
export const defaultRouter = '/cms';

export const CompanyUrl = {
  // Selling
  Selling: {
    Dashboard: `${BaseCompanySellingUrl}/dashboard`,
    TripStatusReport: `${BaseCompanySellingUrl}/trip-status-reports`,
    TripStatusTVScreen: `/cms/tv/trip-status-reports`,
    SalesReport: `${BaseCompanySellingUrl}/reports/sales-report`,
    TripsReport: `${BaseCompanySellingUrl}/reports/trips-report`,
    TripDetailsReport: `${BaseCompanySellingUrl}/reports/trip-details-report`,
    TripIncomeReport: `${BaseCompanySellingUrl}/reports/trip-income-report`,
    UnEarnedRevenueReport: `${BaseCompanySellingUrl}/reports/un-earned-revenue-report`,
    SaleWithGroupReport: `${BaseCompanySellingUrl}/reports/sale-with-group-report`,
  },

  // Management
  Management: {
    Dashboard: `${BaseCompanyManagementUrl}/dashboard`,
    Stations: `${BaseCompanyManagementUrl}/stations`,
    Notifications: `${BaseCompanyManagementUrl}/notifications`,
    TicketClasses: `${BaseCompanyManagementUrl}/fleets/ticket-classes`,
    SeatModels: `${BaseCompanyManagementUrl}/fleets/seat-models`,
    Buses: `${BaseCompanyManagementUrl}/buses/manage-buses`,
    BusModels: `${BaseCompanyManagementUrl}/buses/bus-models`,
    Passengers: `${BaseCompanyManagementUrl}/passengers`,
    Routes: `${BaseCompanyManagementUrl}/routes-and-trips/routes`,
    BaggageTariffs: `${BaseCompanyManagementUrl}/routes-and-trips/baggage-tariffs`,
    TicketTariffs: `${BaseCompanyManagementUrl}/routes-and-trips/ticket-tariffs`,
    Trips: `${BaseCompanyManagementUrl}/routes-and-trips/trips`,
    TripDetails: `${BaseCompanyManagementUrl}/trip-details`,
    TripsCalendar: `${BaseCompanyManagementUrl}/trips-calendar`,
    Registers: `${BaseCompanyManagementUrl}/registers`,
    Terminals: `${BaseCompanyManagementUrl}/terminals`,
    Tickets: `${BaseCompanyManagementUrl}/tickets`,
    Bookings: `${BaseCompanyManagementUrl}/bookings`,
    TicketConflict: `${BaseCompanyManagementUrl}/ticket-conflict`,
    TariffAgeIssues: `${BaseCompanyManagementUrl}/tariff-age-issues`,
    ControlReviews: `${BaseCompanyManagementUrl}/control-reviews`,
    CreditNotes: `${BaseCompanyManagementUrl}/credit-notes`,
    SellOnTheGoBookings: `${BaseCompanyManagementUrl}/sell-on-the-go-bookings`,
    SellOnTheGoReconciliations: `${BaseCompanyManagementUrl}/sell-on-the-go-reconciliations`,
    BaggageReconciliations: `${BaseCompanyManagementUrl}/baggage-reconciliations`,
    ShipmentManagement: `${BaseCompanyManagementUrl}/shipment-management`,
  },
  // Growing
  Growing: {
    Dashboard: `${BaseCompanyGrowingUrl}/dashboard`,
    Discounts: `${BaseCompanyGrowingUrl}/discounts`,
    CompanySettings: `${BaseCompanyGrowingUrl}/company-settings`,
    Subscriptions: `${BaseCompanyGrowingUrl}/subscriptions`,
    Staffs: `${BaseCompanyGrowingUrl}/staffs`,
    Roles: `${BaseCompanyGrowingUrl}/roles`,
  },
};

export const CompanyPermissionConfig = {
  // Selling
  [CompanyUrl.Selling.Dashboard]: [APP_PERMISSIONS.ViewCompanyDashboard],
  [CompanyUrl.Selling.TripStatusTVScreen]: [APP_PERMISSIONS.ViewTripStatus],

  [CompanyUrl.Selling.TripStatusReport]: [APP_PERMISSIONS.ViewTripStatus],
  [CompanyUrl.Selling.TripsReport]: [APP_PERMISSIONS.ViewCompanyReport],
  [CompanyUrl.Selling.SalesReport]: [APP_PERMISSIONS.ViewCompanyReport],
  [CompanyUrl.Selling.TripDetailsReport]: [APP_PERMISSIONS.ViewCompanyReport],
  [CompanyUrl.Selling.TripIncomeReport]: [APP_PERMISSIONS.ViewCompanyReport],
  [CompanyUrl.Selling.UnEarnedRevenueReport]: [APP_PERMISSIONS.ViewCompanyReport],
  [CompanyUrl.Selling.SaleWithGroupReport]: [APP_PERMISSIONS.ViewCompanyReport],

  // Management

  [CompanyUrl.Management.Dashboard]: [APP_PERMISSIONS.ViewCompanyDashboard],
  [CompanyUrl.Management.Stations]: [APP_PERMISSIONS.ViewStationsOnly, APP_PERMISSIONS.ManageStations],
  [CompanyUrl.Management.Notifications]: [APP_PERMISSIONS.ViewNotifications],

  [CompanyUrl.Management.TicketClasses]: [APP_PERMISSIONS.ViewFleetsTripsTariffs, APP_PERMISSIONS.ManageFleetsTrips],
  [CompanyUrl.Management.SeatModels]: [APP_PERMISSIONS.ViewFleetsTripsTariffs, APP_PERMISSIONS.ManageFleetsTrips],
  [CompanyUrl.Management.Buses]: [APP_PERMISSIONS.ViewFleetsTripsTariffs, APP_PERMISSIONS.ManageFleetsTrips],
  [CompanyUrl.Management.BusModels]: [APP_PERMISSIONS.ViewFleetsTripsTariffs, APP_PERMISSIONS.ManageFleetsTrips],
  [CompanyUrl.Management.Routes]: [APP_PERMISSIONS.ViewFleetsTripsTariffs, APP_PERMISSIONS.ManageFleetsTrips],
  [CompanyUrl.Management.TicketTariffs]: [APP_PERMISSIONS.ViewFleetsTripsTariffs, APP_PERMISSIONS.ManageFleetsTrips],
  [CompanyUrl.Management.Trips]: [APP_PERMISSIONS.ViewFleetsTripsTariffs, APP_PERMISSIONS.ManageFleetsTrips],
  [CompanyUrl.Management.TripDetails]: [
    APP_PERMISSIONS.ViewFleetsTripsTariffs,
    APP_PERMISSIONS.ManageFleetsTrips,
    APP_PERMISSIONS.ExportTravelerReport,
  ],
  [CompanyUrl.Management.TripsCalendar]: [APP_PERMISSIONS.ViewFleetsTripsTariffs, APP_PERMISSIONS.ManageFleetsTrips],
  [CompanyUrl.Management.BaggageTariffs]: [APP_PERMISSIONS.ViewFleetsTripsTariffs, APP_PERMISSIONS.ManageBaggageTariffs],
  [CompanyUrl.Management.Passengers]: [APP_PERMISSIONS.ViewPassengersOnly, APP_PERMISSIONS.ManagePassenger],
  [CompanyUrl.Management.Registers]: [APP_PERMISSIONS.ManageRegisters],
  [CompanyUrl.Management.Terminals]: [APP_PERMISSIONS.ManageRegisters],
  [CompanyUrl.Management.Tickets]: [APP_PERMISSIONS.ViewTicketsOnly, APP_PERMISSIONS.ManageTickets],
  [CompanyUrl.Management.Bookings]: [APP_PERMISSIONS.ManageBookings],
  [CompanyUrl.Management.TicketConflict]: [APP_PERMISSIONS.ViewConflictTicketsOnly, APP_PERMISSIONS.ManageConflictTickets],
  [CompanyUrl.Management.TariffAgeIssues]: [APP_PERMISSIONS.ViewTicketsOnly, APP_PERMISSIONS.ManageTickets],
  [CompanyUrl.Management.ControlReviews]: [APP_PERMISSIONS.ViewTicketsOnly, APP_PERMISSIONS.ManageTickets],
  [CompanyUrl.Management.CreditNotes]: [APP_PERMISSIONS.ViewCreditNotes],
  [CompanyUrl.Management.SellOnTheGoBookings]: [APP_PERMISSIONS.ManageBookings],
  [CompanyUrl.Management.SellOnTheGoReconciliations]: [APP_PERMISSIONS.ManageSellOnTheGoReconciliation],
  [CompanyUrl.Management.BaggageReconciliations]: [APP_PERMISSIONS.ManageBaggageReconciliation],
  // [CompanyUrl.Management.ShipmentManagement]: [APP_PERMISSIONS.Sh],

  // Growing
  [CompanyUrl.Growing.Dashboard]: [APP_PERMISSIONS.ViewCompanyDashboard],
  [CompanyUrl.Growing.Discounts]: [APP_PERMISSIONS.ViewDiscountsOnly, APP_PERMISSIONS.ManageDiscounts],
  [CompanyUrl.Growing.CompanySettings]: [APP_PERMISSIONS.ManageCompanySettings],
  [CompanyUrl.Growing.Subscriptions]: [APP_PERMISSIONS.ManageSubscriptions],
  [CompanyUrl.Growing.Staffs]: [APP_PERMISSIONS.ManageAccounts],
  [CompanyUrl.Growing.Roles]: [APP_PERMISSIONS.ManageAccounts],

  __getPermission(url: string) {
    return (this[url] || ['*']) as any;
  },
};
const routes: Array<RouteType> = [
  // Selling
  { path: CompanyUrl.Selling.Dashboard, component: CompanyDashboard, exact: true },
  { path: CompanyUrl.Selling.TripStatusReport, component: TripStatusReportPage, exact: true },
  { path: CompanyUrl.Selling.SalesReport, component: SalesReportPage, exact: true },
  { path: CompanyUrl.Selling.TripsReport, component: TripsReportPage, exact: true },
  { path: CompanyUrl.Selling.TripDetailsReport, component: TripDetailsReport, exact: true },
  { path: CompanyUrl.Selling.TripIncomeReport, component: TripIncomeReport, exact: true },
  { path: CompanyUrl.Selling.UnEarnedRevenueReport, component: UnEarnedRevenueReport, exact: true },
  { path: CompanyUrl.Selling.SaleWithGroupReport, component: SaleWithGroupReportPage, exact: true },

  // Management
  { path: CompanyUrl.Management.Dashboard, component: CompanyDashboard, exact: true },
  { path: CompanyUrl.Management.Stations, component: StationsPage, exact: true },
  { path: CompanyUrl.Management.Notifications, component: NotificationsPage, exact: true },
  { path: CompanyUrl.Management.SeatModels, component: SeatModelsPage, exact: true },
  { path: CompanyUrl.Management.TicketClasses, component: TicketsClassPage, exact: true },
  { path: CompanyUrl.Management.Buses, component: BusesPage, exact: true },
  { path: CompanyUrl.Management.BusModels, component: BusModelsPage, exact: true },
  { path: CompanyUrl.Management.Passengers, component: PassengersPage, exact: true },
  { path: CompanyUrl.Management.Routes, component: RoutesPage, exact: true },
  { path: CompanyUrl.Management.BaggageTariffs, component: BaggageTariffsPage, exact: true },
  { path: CompanyUrl.Management.TicketTariffs, component: TicketTariffsPage, exact: true },
  { path: CompanyUrl.Management.Trips, component: TripsPage, exact: true },
  { path: CompanyUrl.Management.TripDetails, component: TripDetailsPage, exact: true },
  { path: CompanyUrl.Management.TripsCalendar, component: TripsCalendarPage, exact: true },
  { path: CompanyUrl.Management.Registers, component: RegistersPage, exact: true },
  { path: CompanyUrl.Management.Terminals, component: TerminalsPage, exact: true },
  { path: CompanyUrl.Management.Tickets, component: ManageTicketsPage, exact: true },
  { path: CompanyUrl.Management.Bookings, component: BookingPage, exact: true },
  { path: CompanyUrl.Management.TicketConflict, component: TicketConflictPage, exact: true },
  { path: CompanyUrl.Management.TariffAgeIssues, component: TariffAgeIssuesPage, exact: true },
  { path: CompanyUrl.Management.ControlReviews, component: ControlReviewsPage, exact: true },
  { path: CompanyUrl.Management.CreditNotes, component: CreditNotesPage, exact: true },
  { path: CompanyUrl.Management.SellOnTheGoBookings, component: SellOnTheGoBookingPage, exact: true },
  { path: CompanyUrl.Management.SellOnTheGoReconciliations, component: SellOnTheGoReconciliationPage, exact: true },
  { path: CompanyUrl.Management.BaggageReconciliations, component: BaggageReconciliationPage, exact: true },
  { path: CompanyUrl.Management.ShipmentManagement, component: ShipmentManagementPage, exact: true },

  // Growing
  { path: CompanyUrl.Growing.Dashboard, component: CompanyDashboard, exact: true },
  { path: CompanyUrl.Growing.CompanySettings, component: CompanySettingsPage, exact: true },
  { path: CompanyUrl.Growing.Subscriptions, component: SubscriptionsPage, exact: true },
  { path: CompanyUrl.Growing.Discounts, component: DiscountsPage, exact: true },
  { path: CompanyUrl.Growing.Staffs, component: StaffsPage, exact: true },
  { path: CompanyUrl.Growing.Roles, component: RolesPage, exact: true },
].map(x => ({ ...x, permissions: CompanyPermissionConfig.__getPermission(x.path) }));

export default routes;
